import React, { useState, useEffect } from "react";
import "./StudentAvatar.scss";
import Switch from "react-switch";
import { submitAttendance, setProgramName, getAttendance } from "../../../actions/tutorFeedActions"
import { connect } from "react-redux";
import { successColor } from "../../../actions/utility"
import Snackbar from "../../Snackbar";
import { withRouter, Link } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { daysName, monthNames } from "../../../actions/utility"
import * as Scroll from "react-scroll";
const scoreThing = false;

const StudentAvatar = (props) => {
  const {programSlot , avatarData, programName, programId, submitAttendance, apiAttendanceData, setProgramName, slotId } = props;
  const [attendanceData, setattendanceData] = useState([]);
  const [markAll, setmarkAll] = useState(false);
  const [tempAttendance, settempAttendance] = useState([]);
  const [loggedUserId, setloggedUserId] = useState("");
  const [clientId, setclientId] = useState("");
  const [alreadyMarked, setalreadyMarked] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("black");
  const [snackbarMessage, setsnackbarMessage] = useState("Hello Jee");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [todaysDate, settodaysDate] = useState(new Date());
  const [mobileCheck, setmobileCheck] = useState(false);
  const [attendanceStore, setattendanceStore] = useState();

  useEffect(() => {
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      setloggedUserId(tutorData.user.id);
      setclientId(tutorData.user.client_id)
    }
  }, [])
  if (apiAttendanceData != attendanceStore) {
    try {
      if (typeof avatarData[programName] != "undefined") {
        avatarData[programName].map(item => {
          if (typeof apiAttendanceData[`${programId}||${slotId}`] != "undefined" && typeof apiAttendanceData[`${programId}||${slotId}`][item.student_id] != "undefined") {
            attendanceData.push({
              isChecked: apiAttendanceData[`${programId}||${slotId}`][item.student_id].attendance_status
            })
            setalreadyMarked(true);
          }
          else {
            attendanceData.push({
              isChecked: 0
            })
          }
        })
        avatarData[programName].map(item => {
          tempAttendance.push({
            attendance_status: 0,
            student_id: item.student_id,
            is_customized: item.is_customized
          })
        })
      }
      setattendanceStore(apiAttendanceData)
      console.log("Attendance Array for Design", attendanceData)
      console.log("Attendance Array for API", tempAttendance)
    }
    catch (err) {
      debugger;
    }
  }


  const setAttendanceStatus = (e, indexPrev, stdId, isCustomised) => {
    if (tempAttendance.length != 0) {
      tempAttendance.map((item, index) => {
        if (item.student_id == stdId && item.attendance_status == 0) {
          item.attendance_status = 1
        }
        else if (item.student_id == stdId && item.attendance_status == 1) {
          item.attendance_status = 0
        }
      })
    }
    else {
      var temp = tempAttendance.push({
        attendance_status: 1,
        student_id: stdId,
        is_customized: isCustomised
      })
    }
    //For View Design
    var temp = attendanceData;
    temp.map((item, index) => {
      if (index == indexPrev) {
        if (item.isChecked == true) {
          item.attendanceStatus = "Absent"
          item.isChecked = false
        }
        else {
          item.attendanceStatus = "Present"
          item.isChecked = true
        }
      }
    })
    setattendanceData([...temp])
    settempAttendance([...tempAttendance])
  }

  const handleChange = () => {
    let data = avatarData[programName].map((item, index) => {
      tempAttendance.splice(index);
      if (markAll) {
        tempAttendance.push({
          attendance_status: 0,
          student_id: item.student_id,
          is_customized: item.is_customized
        })
      }
      else {
        tempAttendance.push({
          attendance_status: 1,
          student_id: item.student_id,
          is_customized: item.is_customized
        })
      }
    })


    //for Design View
    var temp = attendanceData;
    temp.map((item) => {
      if (markAll) {
        item.isChecked = false;
      }
      else {
        item.isChecked = true;
      }
    })
    setmarkAll(!markAll)
  }


  if (typeof apiAttendanceData[`${programId}||${slotId}`] == "undefined") {
    console.log("false")
  }
  else {
    console.log("true")
    console.log("AlreadyMarked", alreadyMarked)

  }
  console.log("Attendance Array for Design", attendanceData)
  console.log("Attendance Array for API", tempAttendance)
  console.log("slotId", props.slotId)
  console.log("programSlot", `${programId}||${slotId}`)

  const postAttendance = (e) => {
    submitAttendance(clientId, loggedUserId, programId, tempAttendance, slotId)
      .then(res => {
        if (typeof res != "undefined") {
          setModal(false);
          setsnackbarColor(successColor);
          setsnackbarMessage("Attendance Marked Successfully");
          snackBarFunction();
          var program = programId;
          var slotProgram = `${programId}||${slotId}`;
          setProgramName({ programName, program , slotProgram , slotId });
          debugger;
          // window.location.reload();
          props.history.push('/Teacherdashboard/Evaluation');
          const { innerWidth: width, innerHeight: height } = window;
          if (width < 541) {
            let scroll = Scroll.animateScroll;
            scroll.scrollToBottom();
          }
        }
      })
  }
  const snackBarFunction = () => {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };
  function evaluationFunction(program) {
    var slotProgram = `${programId}||${slotId}`;
    setProgramName({ programName, program , slotProgram , slotId });
    const { innerWidth: width, innerHeight: height } = window;

    // window.scroll({
    //   top: 1500,
    //   left: 0,
    //   behavior: 'smooth',
    // });
    if (width < 541) {
      let scroll = Scroll.animateScroll;
      scroll.scrollToBottom();
    }
  }
  console.log(window.innerWidth);
  return <div className="container">
    <Snackbar color={snackbarColor} msg={snackbarMessage} />
    <div className="row" id="body"> <div className="col-md-12 text-right">
      {!alreadyMarked ? <label>
        {markAll ? <span className="mr-2">All Present</span> : <span className="mr-2">All Absent</span>}
        <Switch
          onChange={handleChange}
          checked={markAll}
          className="switchForPresent"
          checkedIcon={false}
          uncheckedIcon={false}
          height={24}
        />
      </label> : <div className="text-left"> <label className="attendanceLabel">*Attendance already marked for today</label> </div>}
    </div>
      {programName != null && typeof avatarData[programName] != "undefined" ?
        avatarData[programName].map((item, index) => (
          <div key={index} className="col-sm-4 mt-4 mobileView" onClick={!alreadyMarked ? e => setAttendanceStatus(e, index, item.student_id, item.is_customized) : null}>
            {attendanceData.length != 0 ? attendanceData[index].isChecked == false ? (
              <div className="absentCircle"></div>
            ) : (
                <div className="presentCircle"></div>
              ) : ''}
            {item.is_expired == 1 ?
              <span className="dollarSign" style={{ color: "red" }}>
                <i
                  className="fas fa-dollar-sign"
                  style={{ fontSize: 16 }}
                ></i>
              </span> : null}
            {item.is_scheduled_demo == 1 ?
              <span className="newDemoSign" style={{ color: "yellow" }}>
                <i
                  className="fas fa-star"
                  style={{ fontSize: 16 }}
                ></i>
              </span> : null}
            {item.image !== null ? <img src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`} alt="Avatar" className="avatarStudent" /> : <img src={require("../../../public/images/emptyuserphoto.png")} alt="Avatar" className="avatarStudent" />}
            {window.innerWidth > 541 ?
              <br /> : null}
            <label className="MobilelabelAlign m-1">{item.user_name}</label>
            {/* <div style={{ float: "left" }}>
        <i className="fas fa-long-arrow-alt-left iconSize"></i>
        <i className="fas fa-long-arrow-alt-right iconSizeTwo"></i>
      </div> */}
            {scoreThing ?
              <label
                class="badge changeTransition"
                style={{ backgroundColor: "#1a2b47" }}
              >
                {item.value1 == 0 ? (
                  <React.Fragment>
                    <span className="mr-1" style={{ color: "#cdeef4" }}>
                      -
                    </span>
                    <span className="mr-1" style={{ color: "#cdeef4" }}>
                      -
                    </span>

                    <span className="" style={{ color: "#28a745" }}>
                      -
                  </span>
                  </React.Fragment>
                ) : (
                    <React.Fragment>
                      <span className="mr-1" style={{ color: "#cdeef4" }}>
                        {item.value1}
                      </span>
                      <span className="mr-1" style={{ color: "#cdeef4" }}>
                        {item.value2}
                      </span>

                      <span className="" style={{ color: "#28a745" }}>
                        <i
                          className="fas fa-long-arrow-alt-up"
                          style={{ fontSize: 16 }}
                        ></i>

                        {item.value3}
                      </span>
                    </React.Fragment>
                  )}
              </label>
              : attendanceData.length != 0 && attendanceData[index].isChecked == false ? (
                <div className="absentText">Absent</div>
              ) : (
                  <div className="presentText text-success font-weight-bold">Present</div>
                )}
          </div>
        ))
        : null}
    </div>
    {/* <div style={{ backgroundColor: "#4b7ac6", borderRadius: 8 }} className="row mt-2">
      <div className="col-md-12 mt-2">
        <p className="mt-2" style={{ fontSize: 14 }}>Holding Pen:</p>
      </div>
      <div className="col-sm-4 mt-2 mobileView">
        <div className="absentCircle"></div>

        <img src="https://ctt.trains.com/sitefiles/images/no-preview-available.png" alt="Avatar" className="avatarStudent" />
        <label className="MobilelabelAlign m-1" style={{ color: "#fff" }}>Rabil Malik</label>
      </div>
      <div className="col-sm-4 mt-2 mobileView">
        <div className="absentCircle"></div>

        <img src="https://ctt.trains.com/sitefiles/images/no-preview-available.png" alt="Avatar" className="avatarStudent" />
        <label className="MobilelabelAlign m-1" style={{ color: "#fff" }}>Maryam Majid</label>
      </div>
    </div> */}
    <div className="row">
      <div className="col-md-12 mt-4">
        {/* <Link to={'/Teacherdashboard/Planner'}>
        <button className="btn btn-warning btn-sm">Create Planner</button>
      </Link> */}

        {alreadyMarked ?
          <Link to={`/Teacherdashboard/Evaluation`}>
            <div className="text-right">
              <button className="btn btn-dark btn-sm" onClick={() => evaluationFunction(programId)}>Evaluation <i className="fa fa-smile"></i> </button>
            </div>
          </Link>
          : null}
        {!alreadyMarked ?
          <div className="text-right">
            <button className="btn btn-success btn-sm" onClick={toggle}>Submit Attendance</button>
          </div>
          : ''}
      </div>
    </div>
    <div>
      <Modal isOpen={modal} toggle={toggle} centered size="md" className="modalModal" backdrop={true}>
        <ModalHeader className="modalHeaderStyle" toggle={toggle}>Submit Attendance</ModalHeader>
        <ModalBody className="modalHeaderStyle">
          Once you have submitted attendance sheet for today {daysName[todaysDate.getDay() - 1]} {todaysDate.getDate()} {monthNames[todaysDate.getMonth()]}. It can not be changed.
        </ModalBody>
        <ModalFooter className="modalHeaderStyle">
          <Button color="success" onClick={postAttendance}>Submit and Continue</Button>
          <Button color="secondary" onClick={toggle}>Don't Submit Now</Button>
        </ModalFooter>
      </Modal>
      {/* <div class="modal-backdrop fade show"></div> */}
    </div>
  </div>
};

export default withRouter(connect(null, { submitAttendance, setProgramName, getAttendance })(StudentAvatar));